export const IMMAPER_MRF_FORM_ADD_CONNECTION = 'IMMAPER_MRF_FORM_ADD_CONNECTION'
export const IMMAPER_MRF_FORM_DELETE_CONNECTION = 'IMMAPER_MRF_FORM_DELETE_CONNECTION'
// export const IMMAPER_MRF_FORM_MOVEUP = 'IMMAPER_MRF_FORM_MOVEUP'
// export const IMMAPER_MRF_FORM_MOVEDOWN = 'IMMAPER_MRF_FORM_MOVEDOWN'
export const IMMAPER_MRF_FORM_CHANGE_ITINERARY = 'IMMAPER_MRF_FORM_CHANGE_ITINERARY'
export const IMMAPER_MRF_FORM_ONCHANGE = 'IMMAPER_MRF_FORM_ONCHANGE'
export const IMMAPER_MRF_FORM_CHANGE_TRAVEL_DETAIL = 'IMMAPER_MRF_FORM_CHANGE_TRAVEL_DETAIL'
export const IMMAPER_MRF_FORM_ADD_TRAVEL_DETAIL = 'IMMAPER_MRF_FORM_ADD_TRAVEL_DETAIL'
export const IMMAPER_MRF_FORM_DELETE_TRAVEL_DETAIL = 'IMMAPER_MRF_FORM_DELETE_TRAVEL_DETAIL'
export const IMMAPER_MRF_FORM_RESET = 'IMMAPER_MRF_FORM_RESET'
export const MRF_RESET_ITINERARY = 'MRF_RESET_ITINERARY'
export const MRF_RESET_TRAVEL_DETAIL = 'MRF_RESET_TRAVEL_DETAIL'
